import React from 'react';

/**
 * 利用規約の内容を一元管理
 * 
 * 📌 重要：このファイルが唯一の管理元です
 * 
 * 使用箇所：
 * - /src/components/modals/TermsModal.tsx (モーダル表示)
 * - /src/views/TermsView.tsx (ページ表示 /terms)
 * 
 * 変更する場合はこのファイルのみを編集してください。
 * 両方の表示箇所に自動的に反映されます。
 */
export const termsContent = (
  <>
    <section>
      <h3 className="font-semibold mb-2 text-gray-100">第1条（適用）</h3>
      <p className="text-sm text-gray-300">
        本規約は、株式会社ツクルマ（以下「当社」といいます）が提供するAI車画像生成・グッズ作成・ウィンドウデカール製造サービス「AISHA」（以下「本サービス」といいます）の利用条件を定めるものです。
        ユーザーは、本規約に同意の上、本サービスを利用するものとします。
      </p>
    </section>

    <section>
      <h3 className="font-semibold mb-2 text-gray-100">第2条（定義）</h3>
      <p className="text-sm text-gray-300 mb-2">本規約において使用する用語の定義は、次のとおりとします。</p>
      <ul className="list-disc list-inside space-y-1 text-sm text-gray-300">
        <li>「ユーザー」：本サービスを利用する個人</li>
        <li>「愛車写真」：ユーザーが現在または過去に所有していた自動車（マイカー）の写真</li>
        <li>「ペット写真」：ユーザーが飼育するペット（猫・犬等）の写真</li>
        <li>「生成画像」：本サービスのAI機能により生成された画像</li>
        <li>「グッズ」：生成画像を使用して作成される商品</li>
        <li>「デカール」：ペット写真等をもとにAIがデザインし、愛車のウィンドウサイズにカットして製造されるウィンドウデカール商品</li>
        <li>「施工」：デカールを車両に貼り付ける作業。当社協力パートナーまたは当社が紹介する施工店が行います</li>
      </ul>
    </section>

    <section>
      <h3 className="font-semibold mb-2 text-gray-100">第3条（サービス内容）</h3>
      <ul className="list-disc list-inside space-y-1 text-sm text-gray-300">
        <li>AI技術を用いた愛車写真からの画像生成</li>
        <li>生成画像を使用したオリジナルグッズの作成・購入</li>
        <li>グッズの製造・配送は当社提携先（Printful）が行います</li>
        <li>ペット写真からAIがデザインするウィンドウデカールの製造・販売</li>
        <li>デカールの製造・カットは当社協力パートナー（ARTISAN INC）が行います</li>
        <li>デカールの施工サービス（オプション。来店または当社紹介の施工店にて実施）</li>
      </ul>
    </section>

    <section>
      <h3 className="font-semibold mb-2 text-gray-100">第4条（アカウント登録）</h3>
      <ul className="list-disc list-inside space-y-1 text-sm text-gray-300">
        <li>本サービスは個人向けサービスです。法人利用については別途ご相談ください。</li>
        <li>MyGarageアカウントまたは電話番号認証によりログインできます。</li>
      </ul>
    </section>

    <section>
      <h3 className="font-semibold mb-2 text-gray-100">第5条（画像の利用と権利）</h3>
      <ul className="list-disc list-inside space-y-1 text-sm text-gray-300">
        <li>ユーザーは愛車写真およびご自身が飼育するペットの写真を本サービスで利用できます。</li>
        <li>他人が所有する車両の写真や他人のペットの写真を無断で利用した画像生成は原則できません。</li>
        <li>生成画像の利用権はユーザーに帰属します。ただし、法令上著作権が発生しない場合があります。</li>
        <li>公開設定した画像は、当社がサービスの改善・宣伝目的で利用する場合があります。</li>
      </ul>
    </section>

    <section>
      <h3 className="font-semibold mb-2 text-gray-100">第6条（禁止事項）</h3>
      <p className="text-sm text-gray-300 mb-2">ユーザーは、以下の行為を行ってはなりません。</p>
      <ul className="list-disc list-inside space-y-1 text-sm text-gray-300">
        <li>法令または公序良俗に違反する行為</li>
        <li>第三者の著作権、肖像権、プライバシー等を侵害する行為</li>
        <li>他人が所有する車両や他人のペットの写真を無断で使用する行為</li>
        <li>本サービスの運営を妨害する行為</li>
      </ul>
    </section>

    <section>
      <h3 className="font-semibold mb-2 text-gray-100">第7条（グッズ・デカールの購入）</h3>
      <ul className="list-disc list-inside space-y-1 text-sm text-gray-300">
        <li>グッズの購入・製造・配送・返品等については、Printfulの規約に準じます。</li>
        <li>デカールの注文は、仮申し込み（クレジットカード決済）後、確認ボードにて車種・ウィンドウ箇所等を確認のうえ、正式注文となります。</li>
        <li>正式注文前（お客様確認中）であれば、キャンセルが可能です。キャンセル時はクレジット決済の全額返金を行います。</li>
        <li>正式注文後（製造開始後）のキャンセル・返品はお受けできません。</li>
        <li>デカールはオーダーメイド商品のため、お客様都合による返品・交換はお受けできません。</li>
        <li>施工オプションをご利用の場合、施工店での作業に起因する損害については施工店の責任となります。</li>
        <li>デカールの価格には配送料が含まれます。表示価格はすべて税込です。</li>
      </ul>
    </section>

    <section>
      <h3 className="font-semibold mb-2 text-gray-100">第8条（免責事項）</h3>
      <p className="text-sm text-gray-300">
        当社は、AI生成画像の品質、精度、期待との相違について責任を負いません。
        デカールについては、素材の特性上、色味や仕上がりが画面表示と異なる場合があります。
        ただし、消費者契約法その他の法令により当社に責任を免除できない場合は、この限りではありません。
      </p>
    </section>

    <section>
      <h3 className="font-semibold mb-2 text-gray-100">第9条（個人情報）</h3>
      <p className="text-sm text-gray-300">個人情報の取扱いについては、当社が別途定めるプライバシーポリシーに従います。</p>
    </section>

    <section>
      <h3 className="font-semibold mb-2 text-gray-100">第10条（準拠法・管轄）</h3>
      <ul className="list-disc list-inside space-y-1 text-sm text-gray-300">
        <li>本規約は日本法に準拠します。</li>
        <li>本サービスに関して生じた紛争については、当社本店所在地を管轄する横浜地方裁判所または横浜簡易裁判所を第一審の専属的合意管轄裁判所とします。</li>
        <li>ただし、消費者契約に該当する場合には、消費者契約法に基づき、利用者の住所地を管轄する裁判所に提起することができます。</li>
      </ul>
    </section>

    <section className="border-t border-gray-700 pt-4">
      <h3 className="font-semibold mb-2 text-gray-100">お問い合わせ先</h3>
      <ul className="list-none space-y-1 text-sm text-gray-300">
        <li>サービス名：AISHA</li>
        <li>運営会社：株式会社ツクルマ</li>
        <li>メール：info@mygarage.jp</li>
      </ul>
    </section>

    <section>
      <p className="text-sm text-gray-400">制定日：2025年1月27日</p>
      <p className="text-sm text-gray-400">改定日：2026年3月31日（ウィンドウデカールサービス追加に伴う改定）</p>
    </section>
  </>
);